<script>
	// NPM Modules
	import { onMount } from 'svelte';
	import PreferenceStore from '@/Stores/PreferenceStore.js';

	export let betCount = 0;

	let player;
	let playing = false;

	$: player && betCount && playAlert();

	function playAlert() {
		if ($PreferenceStore.app.muteAlert) return;
		if (player && !playing && betCount > 0) {
			playing = true;
			player
				.play()
				.catch(() => {
					setTimeout(() => {
						playAlert();
					}, 500);
				})
				.finally(() => (playing = false));
		}
	}

	onMount(() => {
		try {
			player = new Audio(`/sounds/${$PreferenceStore.app.alertSound || 'charge'}.mp3`);
			player.addEventListener('ended', () => {
				setTimeout(() => {
					playAlert();
				}, 500);
			});
			player.addEventListener('error', () => {
				setTimeout(() => {
					playAlert();
				}, 500);
			});
		} catch (error) {
			console.log('Init Alert Audio Player', { error });
		}
	});
</script>
